
































































































































































import IWarehouseContacts from '@/store/models/IWarehouseContacts';
import IListPhonePrefix from '@/store/models/IListPhonePrefix';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';

@Component({
    components: {
        Snackbar
    }
})
export default class WarehouseContactsSelector extends Vue {
    searchWarehouseContacts: string = "";
    isValid: boolean = true;
    dialog: boolean = false;
    sortBy: string = 'name';
    sortDesc: boolean = false;
    headers: any = [
        { text: 'Name',
            align: 'start',
            value: 'name'
        },
        { text: 'Email', value: 'email' },
        { text: 'Prefix', value: 'prefix' },
        { text: 'Phone Number', value: 'phoneNumber' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];
    editedIndex : number = -1;
    editedItem : IWarehouseContacts = {
        id: "",
        name: "",
        email: "",
        prefix: "",
        idListPhonePrefix: "",
        phoneNumber: "",
        idWarehouse: ""
    }
    defaultItem : IWarehouseContacts = {
        id: "",
        name: "",
        email: "",
        prefix: "",
        idListPhonePrefix: "",
        phoneNumber: "",
        idWarehouse: ""
    }

    @Prop({ type: Array, required: true })
    WarehouseContactsList !: IWarehouseContacts[];
    @Prop({ type: Array, required: true })
    ListPhonePrefix !: IListPhonePrefix[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    
    selectedWarehouseContact : IWarehouseContacts[] = [];
    selectedPhonePrefix: any = null;
    phonePrefixCountry : string[] = [];

    get ListPhonePrefixesSort () {
        return this.ListPhonePrefix.sort((n1, n2) => {
            if (n1.country > n2.country) {
                return 1;
            }

            if (n1.country < n2.country) {
                return -1;
            }

            return 0;
        });
    }

    get formTitle() { return this.editedIndex === -1 ? 'New Warehouse Contact' : 'Edit Warehouse Contact'; }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    editWarehouseContacts (item: any, dbox = true) {
        if (this.selectedWarehouseContact.length > 0) {
            this.editedIndex = this.WarehouseContactsList.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.selectedPhonePrefix = this.ListPhonePrefix.find(p => p.id === this.editedItem.idListPhonePrefix);
            this.dialog = true;
        }
    }

    saveWarehouseContacts (warehouseContact: IWarehouseContacts) {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            this.setCountryPrefix();
            if (this.editedIndex > -1) {
                this.$emit('editWarehouseContact', this.editedItem);
                Object.assign(this.WarehouseContactsList[this.editedIndex], this.editedItem);
            } else {
                this.$emit('saveWarehouseContact', this.editedItem);
            }
            this.close();
        } else {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
        }
    }

    deleteWarehouseContacts (warehouseContact: IWarehouseContacts) {
        if (this.selectedWarehouseContact.length > 0) {
            this.$emit('deleteWarehouseContact', warehouseContact);
            this.close();
        }
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    setCountryPrefix() {
        if (this.selectedPhonePrefix) {
            let phonePrefix: IListPhonePrefix = this.ListPhonePrefix.find(p => p.country === this.selectedPhonePrefix.country)!;
            if (phonePrefix) {
                this.editedItem.idListPhonePrefix = phonePrefix.id;
                this.editedItem.prefix = phonePrefix.prefix;
            }
        }
    }

    select(item : IWarehouseContacts) : void {
        let index : number = this.selectedWarehouseContact.findIndex(w => w.id === item.id);
        if (index === -1) {
            this.selectedWarehouseContact = [item];
        } else {
            let warehouseContact = this.selectedWarehouseContact.find(w => w.id === item.id);
            if (!warehouseContact) {
                this.selectedWarehouseContact = [];
            }
        }
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
